import type {
	CollectionGridPiece,
	Document,
	ProductVariant,
} from "@workspace/crystallize/generated/discovery/";
import { ArrowRightIcon } from "lucide-react";
import { Link } from "react-router";
import ProductCard from "~/components/product/product-card";

export default function Collection({
	collectionGrid,
	title,
}: CollectionGridPiece) {
	if (!collectionGrid?.items?.length || !title) {
		return null;
	}

	const path = collectionGrid.items[0]?.children
		? collectionGrid.items[0]?.path
		: null;
	const displayTitle = title ?? collectionGrid.items[0]?.name;
	const items = collectionGrid.items || collectionGrid.variants;

	return (
		<section className="container px-4 md:px-6">
			<div className="mb-4 flex items-center justify-between">
				{displayTitle && (
					<h2 className="text-left font-light text-3xl text-primary tracking-tighter sm:text-4xl md:text-5xl">
						{displayTitle}
					</h2>
				)}
				{path && (
					<Link
						to={path}
						className="flex items-center gap-1 rounded-2xl bg-primary/90 px-3 py-2 text-sm text-white"
					>
						<span>Se alle</span>
						<ArrowRightIcon className="h-4 w-4" />
					</Link>
				)}
			</div>
			{collectionGrid && (
				<div className="scrollbar-hide -mx-4 flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto py-1 md:mx-0 md:grid md:grid-cols-2 md:flex-wrap md:gap-6 md:p-1 lg:grid-cols-4">
					{items
						?.slice(0, 4)
						.filter((product): product is Document => product !== null)
						.map((product, index) => (
							<Link
								to={product?.path ?? ""}
								key={product.id}
								className="flex w-[60%] shrink-0 grow-0 basis-auto snap-start flex-col overflow-hidden rounded-lg bg-white ring-2 ring-primary/15 transition-all duration-300 first:ml-4 hover:ring-primary sm:w-[40%] md:w-auto md:snap-align-none md:first:ml-0"
								prefetch="intent"
								viewTransition
							>
								<ProductCard
									{...product}
									index={index}
									sizes="(max-width: 640px) 60vw, (max-width: 768px) 40vw, (max-width: 1024px) 50vw, 290px"
								/>
							</Link>
						))}
				</div>
			)}
		</section>
	);
}
